import {useInfiniteQuery, useQuery} from '@tanstack/react-query'
import {apiClient} from '../restClient'
import {
  GET_EMPLOYEE_USERS_ENDPOINT,
  GET_INITIATIVE_PEOPLE_ENDPOINT,
} from './endPoints'
import type {IPerson, IUser} from '../types'

const fetchInitiativePeoples = (initID: string): Promise<IPerson[]> =>
  apiClient
    .get(`${GET_INITIATIVE_PEOPLE_ENDPOINT}/${initID}/people`)
    .then(r => r.data)

const fetchEmployeeUsersPage = (
  page: number,
  perPage: number,
): Promise<IUser[]> =>
  apiClient
    .get(GET_EMPLOYEE_USERS_ENDPOINT, {
      params: {limit: perPage, offset: (page - 1) * perPage},
    })
    .then(r => r.data)

export const empowerApi = {
  useInitiativePeoples: (initID: string | undefined) =>
    useQuery({
      queryKey: ['empower', 'initiativePeoples', initID],
      queryFn: () => fetchInitiativePeoples(initID!),
      enabled: !!initID,
    }),
  useEmployeeUsers: (perPage: number) =>
    useInfiniteQuery({
      queryKey: ['empower', 'employeeUsers', perPage],
      queryFn: ({pageParam}: {pageParam: number}): Promise<IUser[]> =>
        fetchEmployeeUsersPage(pageParam, perPage),
      initialPageParam: 1,
      getNextPageParam: (lastPage: IUser[], allPages: IUser[][]) =>
        lastPage.length === perPage ? allPages.length + 1 : undefined,
    }),
} as const
